import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import DataTable from 'react-data-table-component';
import Loader from 'components/ui/Loader';
import columns from './columns';
import { useContext } from './Context';

export default function Table({ memberId }) {
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.load(dispatch, memberId);
  }, []);

  if (state.programs === null) {
    return <Loader state />;
  }

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns}
        data={state.programs}
        noDataComponent={(
          <div className="mt20">
            Member has no Programs yet.
          </div>
        )}
        persistTableHead
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: 'All',
        }}
      />
    </div>
  );
}

Table.propTypes = {
  memberId: PropTypes.number.isRequired,
};
